module.exports = __webpack_public_path__ + "img/levelback2.c3efacac.svg";